import React from "react"
import { AppBulkEditAction } from "@components"
import { useUserSettingsOfficesGroup, useUserSettingsOfficesGroupValidator } from "../../@hooks"


export default function UserSettingTierDrawerSubmit() {
	const { isLoading, handleSubmitOfficesGroupFormData } = useUserSettingsOfficesGroup()
	const { isValid } = useUserSettingsOfficesGroupValidator()

	return <AppBulkEditAction
		loading={isLoading}
		disabled={!isValid}
		onClick={handleSubmitOfficesGroupFormData}
	>
		Save
	</AppBulkEditAction>
}